import * as Sentry from '@sentry/browser'

import { sentryOptions } from './constants'

if ('FinvizSentrySettings' in window && !('sentryDisabled' in window)) {
  Sentry.init({
    ...sentryOptions,
    beforeSend(event: Sentry.Event) {
      if ('sentryDisabled' in window) {
        return null
      }
      return event
    },
  })

  if (FinvizSentrySettings.id > 0) {
    Sentry.setUser({ id: String(FinvizSentrySettings.id) })
  }

  try {
    Sentry.setTags({
      dpr: window.devicePixelRatio,
      redesign: window.FinvizSettings?.hasRedesignEnabled,
      dark: window.FinvizSettings?.hasDarkTheme,
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
    })
  } catch {}
}

window['Sentry'] = {
  captureException: Sentry.captureException,
  captureMessage: Sentry.captureMessage,
  withScope: Sentry.withScope,
}
